import { render, staticRenderFns } from "./PaginatedScroll.vue?vue&type=template&id=a390ebf4&"
import script from "./PaginatedScroll.vue?vue&type=script&lang=js&"
export * from "./PaginatedScroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports